import React, { Component } from 'react';
import { label } from '../../utilities/resources';

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { username } = global.window;
    return (
      <div id="universal_header_container">
        <div id="header--container" className="uhf-responsive">
          <div id="uhf-header--container">
            <header>
              <div className="uhf-logo">
                <a href="https://home.manheim.com/landingPage">
                  <img
                    src="https://site.manheim.com/wp-content/uploads/sites/2/2024/07/OMIY_lockup.svg"
                    alt="Manheim logo"
                  />
                </a>
              </div>
              <div className="logout-container">
                <span className="username">{`${label.Welcome} ${username || ''}`}</span>
              </div>
            </header>
          </div>
        </div>
      </div>
    );
  }
}
